<template>
  <container :class="['page-wrapper']">
    <flex :spacing="3">
      <flex-col :span="24">
        <test-toolbar>
          <checkbox label-size="xs" :icon-color="$root.$colors.primary" :label="$lang.capLine" :icon-color-lightness="$root.$colors.bgColorLightness" v-model="capLine" />
        </test-toolbar>
      </flex-col>
      <flex-col :span="24">
        <h-three />
        <card>
          <card-text>
            <timeline v-if="items.length" fixed-width :cap-line="capLine">
              <timeline-item v-for="(item, index) in items" :key="index">
                <timeline-item-date v-html="item.date" x-align="right" v-if="isEven(index)" />
                <timeline-item-info x-align="left" v-if="!isEven(index)">
                  <card>
                    <card-title :bg-color="item.barBgColor" :bg-color-lightness="500" color="white" v-html="$lang.event(index)" />
                    <card-text>
                      <lorem-ipsum />
                    </card-text>
                  </card>
                </timeline-item-info>
                <timeline-item-bar
                  @click="onIconClick(item)"
                  :cursor="cursor"
                  :icon-color="iconColor"
                  :bar-color="barColor"
                  :width="width"
                  :bar-width="barWidth"
                  :bar-bg-color="item.barBgColor"
                  :bar-bg-color-lightness="500"
                  :icon="item.icon"
                  :icon-color-lightness="null"
                  :bar-color-lightness="200" />
                <timeline-item-date v-html="item.date" x-align="left" v-if="!isEven(index)" />
                <timeline-item-info x-align="left" v-if="isEven(index)">
                  <card>
                    <card-title :bg-color="item.barBgColor" :bg-color-lightness="500" color="white" v-html="$lang.event(index)" />
                    <card-text>
                      <lorem-ipsum />
                    </card-text>
                  </card>
                </timeline-item-info>
              </timeline-item>
            </timeline>
          </card-text>
        </card>
        <h-three />
        <card>
          <card-text>
            <timeline v-if="items.length" :cap-line="capLine">
              <timeline-item v-for="(item, index) in items" :key="index">
                <timeline-item-date v-html="item.date" x-align="right" />
                <timeline-item-bar
                  @click="onIconClick(item)"
                  :cursor="cursor"
                  :icon-color="iconColor"
                  :bar-color="barColor"
                  :width="width"
                  :bar-width="barWidth"
                  :bar-bg-color="item.barBgColor"
                  :bar-bg-color-lightness="500"
                  :icon="item.icon"
                  :icon-color-lightness="null"
                  :bar-color-lightness="200" />
                <timeline-item-info>
                  <card>
                    <card-title :bg-color="item.barBgColor" :bg-color-lightness="500" color="white" v-html="$lang.event(index)" />
                    <card-text>
                      <lorem-ipsum />
                    </card-text>
                  </card>
                </timeline-item-info>
              </timeline-item>
            </timeline>
          </card-text>
        </card>
        <h-three />
        <card>
          <card-text>
            <timeline v-if="items.length" width="320px" fixed-width :class="['m-auto']" :cap-line="capLine">
              <timeline-item v-for="(item, index) in items" :key="index">
                <timeline-item-bar
                  @click="onIconClick(item)"
                  :cursor="cursor"
                  :icon-color="iconColor"
                  :bar-color="barColor"
                  :width="width"
                  :bar-width="barWidth"
                  :bar-bg-color="item.barBgColor"
                  :bar-bg-color-lightness="500"
                  :icon="item.icon"
                  :icon-color-lightness="null"
                  :bar-color-lightness="200" />
                <timeline-item-date v-html="item.date" x-align="left" />
                <timeline-item-info x-align="left">
                  <card>
                    <card-title :bg-color="item.barBgColor" :bg-color-lightness="500" color="white" v-html="$lang.event(index)" />
                    <card-text padding-off>
                      <lazy-image
                        :placeholder-bg-color="$dark ? 'black' : 'white'"
                        :placeholder-bg-color-lightness="null"
                        :placeholder-icon-color="$root.colors.primary"
                        :placeholder-icon-color-lightness="$root.colors.bgColorLightness"
                        :src="`${$root.config.staticAssetsDir}/images/guitars/strandberg-boden-prog-7/image-0${index + 1}.jpg`" />
                    </card-text>
                  </card>
                </timeline-item-info>
              </timeline-item>
            </timeline>
          </card-text>
        </card>
      </flex-col>
    </flex>
  </container>
</template>
<script>
import methods from '../../mixins/methods'

export default {
  name: 'PageTimeline',
  mixins: [
    methods
  ],
  data () {
    return {
      items: [],
      barWidth: '4px',
      width: '15%',
      barColor: 'gray',
      iconColor: 'white',
      cursor: 'pointer',
      capLine: true
    }
  },
  mounted () {
    this.getExternalData('timeline.json', 'items')
  },
  methods: {
    onIconClick (item) {
      this.log('click', 'timeline-item-bar', item)
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/pages/ui/timeline.vue